module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/feature1@1x.61743ff.jpg";